import React from "react";
import "./About.css";

function About(props) {
    return (
        <div className="about__container">
            <span>
                "this pages is made by RaccoonCode ! it's an App movies introduce about title, rating, summary, poster"
            </span>
            <span>- Admin RaccoonCode</span>
        </div>
    );
}

export default About;
